import { render } from "./DashboardTabs.vue?vue&type=template&id=6fe133e2"
import script from "./DashboardTabs.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.vue?vue&type=script&lang=js"

import "./DashboardTabs.vue?vue&type=style&index=0&id=6fe133e2&lang=scss"
script.render = render

export default script